import React, { Fragment, useState } from 'react'
import MergeOrganizations from './MergeOrganizations'
import OrganizationsTabs from './OrganizationsTabs'
import OrgReview from './ReviewOrganizations/OrgReview'
import { ORG_REVIEW_TAB, MERGE_TAB } from './OrganizationsTabs'

const ManageOrganizations = () => {
    const [activeTab, setActiveTab] = useState(ORG_REVIEW_TAB)

    if (activeTab === MERGE_TAB) {
        return (
            <Fragment>
                <OrganizationsTabs
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                />
                <MergeOrganizations />
            </Fragment>
        )
    }

    return (
        <Fragment>
            <OrganizationsTabs activeTab={activeTab} onTabChange={setActiveTab} />
            <OrgReview />
        </Fragment>
    )
}

export default ManageOrganizations